import { Link, withRouter } from "react-router-dom";

export default withRouter(function Button({
  children,
  to,
  cancel,
  staticContext,
  ...props
}) {
  if (cancel) {
    return (
      <button
        className="cancel-button"
        type="button"
        onClick={() => props.history.goBack()}
        {...props}
      >
        {children}
      </button>
    );
  }

  if (to) {
    return (
      <Link to={to} {...props}>
        <button className={props.className}>{children}</button>
      </Link>
    );
  }

  return (
    <button className={props.className} {...props}>
      {children}
    </button>
  );
});
